let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jf7jK")).then(() => parcelRequire('co8Yt'));